import Banner from '@sats-group/ui-lib/react/banner';
import Text from '@sats-group/ui-lib/react/text';
import React, { useState } from 'react';
import CheckboxCard from '~/client/components/checkbox-card/checkbox-card';
import type {
  InteractionHandler,
  Radio as RadioNode,
} from '~/client/components/option-card/option-card.types';
import OptionCardGroup from '~/client/components/option-card-group/option-card-group';
import PaymentV2 from '~/client/components/payment-v2/payment-v2';
import RichText from '~/client/components/rich-text/rich-text';
import SelfServiceSummary from '~/client/components/self-service-summary/self-service-summary';
import ShopInstallments from '~/client/components/shop-installments/shop-installments';
import ShopLayout from '~/client/components/shop-layout/shop-layout';
import type { BootCampShopPay as Props } from './boot-camp-shop-pay.types';

const Primary = () => null;

const Secondary = SelfServiceSummary;

const Tertiary = ({
  installments,
  payment,
  paymentSectionTitle,
  terms,
  toggler,
}: NonNullable<Props['layout']['tertiary']>) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [activeOption, setActiveOption] = useState<string>();

  const handleOptionCardGroupInteraction: InteractionHandler<
    RadioNode
  > = self => setActiveOption(self.id);

  const handleTermsChange = () => setTermsAccepted(value => !value);

  return (
    <div className="boot-camp-shop-pay__tertiary">
      <div data-testid="terms">
        <CheckboxCard
          {...terms.checkbox}
          inputOverrides={{
            onChange: handleTermsChange,
            checked: termsAccepted,
          }}
        >
          <RichText {...terms.content} />
        </CheckboxCard>
      </div>
      <Text
        elementName="h2"
        size={Text.sizes.large}
        theme={Text.themes.emphasis}
        tight
      >
        {paymentSectionTitle}
      </Text>
      {termsAccepted ? (
        <React.Fragment>
          <OptionCardGroup
            {...toggler.props}
            onInteraction={handleOptionCardGroupInteraction}
          />
          {installments && toggler.installmentId === activeOption ? (
            <ShopInstallments {...installments} />
          ) : null}
          {payment && toggler.paymentId === activeOption ? (
            <PaymentV2 {...payment} />
          ) : null}
        </React.Fragment>
      ) : (
        <Banner list={[]} text={terms.info} type="neutral" />
      )}
    </div>
  );
};

const BootCampShopPay: React.FC<Props> = ({ layout }) => (
  <ShopLayout
    {...layout}
    primaryRenderer={Primary}
    secondaryRenderer={Secondary}
    tertiaryRenderer={Tertiary}
  />
);

export default BootCampShopPay;
